import { useLayoutEffect, useRef } from 'react';
// Our dialogs open from state, not from a Radix trigger, so Radix has nowhere to send focus when
// they close. This keeps what had focus as the dialog opened; the dialog focuses it again on close.
export function useReturnFocus(open) {
    const opener = useRef(null);
    useLayoutEffect(() => {
        if (open)
            opener.current = focusOrigin();
    }, [open]);
    return opener;
}
export function returnFocusTo(opener) {
    return (event) => giveFocusBack(event, opener.current);
}
// Where a dialog gives focus back as it closes: what had focus as it opened or, for an item of a
// menu that closes as the dialog opens, the button that opened the menu.
export function focusOrigin() {
    const active = document.activeElement;
    if (!(active instanceof HTMLElement) || active === document.body)
        return null;
    const trigger = active.closest('[role="menu"]')?.getAttribute('aria-labelledby');
    return (trigger ? document.getElementById(trigger) : null) ?? active;
}
// For a dialog's onCloseAutoFocus. Focus that moved on while the dialog closed, as to the title of
// a page it opened, stays there; focus left on the page itself goes back to `origin`.
export function giveFocusBack(event, origin) {
    if (event.defaultPrevented)
        return;
    const active = document.activeElement;
    if (active instanceof HTMLElement && active !== document.body) {
        event.preventDefault();
    }
    else if (origin?.isConnected) {
        event.preventDefault();
        origin.focus();
    }
}
//# sourceMappingURL=return-focus.js.map